import styled from "@emotion/styled"
import Reconbg from "../../images/reconbg1.jpg"

export const MainContainer = styled.div`
  height: 100vh;

  background-repeat: no-repeat;

  padding-top: 141px;
  margin-bottom: 13px;

  background-size: cover;
  background-position: center center;
  width: 100%;

  /* opacity: 1; */
  visibility: inherit;
  /* z-index: 20; */
  padding-bottom: 90px;
  ::before {
    content: "";
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.7;
    background-image: linear-gradient(135deg, #0100ec, #fb36f4);
    background: #4f3ec8;
  }
  @media (max-width: 600px) {
    /* height:auto; */
    padding-top: 90px;
    padding-bottom: 90px;
  }
`

export const InnerContainer = styled.div`
  width: 85%;
  margin: auto;
`
export const SubHeading = styled.div`
  z-index: 6;
  min-width: 536px;
  max-width: 536px;
  white-space: normal;
  font-size: 17px;
  line-height: 30px;
  font-weight: 400;
  color: rgb(255, 255, 255);
  letter-spacing: 0px;
  font-family: Poppins;
  visibility: inherit;
  transition: none 0s ease 0s;
  text-align: inherit;
  border-width: 0px;
  margin: 0px;
  padding: 0px;
  min-height: 0px;
  max-height: none;
  opacity: 1;
  transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  transform-origin: 50% 50% 0px;
  margin-top: 14px;
  @media (max-width: 600px) {
    width: 95%;
    min-width: 95%;
    max-width: 95%;
    line-height: 30px;
  }
`

export const DateText = styled.div`
  z-index: 8;
  white-space: nowrap;
  font-size: 18px;
  line-height: 32px;
  font-weight: 400;
  color: rgb(255, 255, 255);
  letter-spacing: 2px;
  font-family: Rubik;
  font-style: italic;
  visibility: inherit;
  transition: none 0s ease 0s;
  text-align: inherit;
  border-width: 0px;
  margin: 0px;
  padding: 0px;
  min-height: 0px;
  min-width: 0px;
  max-height: none;
  max-width: none;
  opacity: 1;
  transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  transform-origin: 50% 50% 0px;
`

export const Heading = styled.div`
  z-index: 5;
  /* min-width: 585px;
max-width: 585px; */
  width: 592px;
  white-space: normal;
  font-size: 60px;
  line-height: 83px;
  font-weight: 700;
  color: rgb(255, 255, 255);
  letter-spacing: 0px;
  font-family: Poppins;
  visibility: inherit;
  transition: none 0s ease 0s;
  text-align: inherit;
  border-width: 0px;
  margin: 0px;
  padding: 0px;
  min-height: 0px;
  max-height: none;
  height: 169px;
  opacity: 1;
  transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  transform-origin: 50% 50% 0px;

  @media (max-width: 664px) {
    width: 99%;
    height: auto;
    font-size: 50px;
    line-height: 55px;
  }
  @media (max-width: 350px) {
    font-size: 42px;
  }
`
